import { render, staticRenderFns } from "./edit-title.vue?vue&type=template&id=588494df"
import script from "./edit-title.vue?vue&type=script&lang=js"
export * from "./edit-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports